/* eslint-disable no-undef */
/**
 * Create a ecommerce event item with data retrieved from all data-item-xxx in the HTML
 * element that triggers the event
 *
 * @param {*} data - This data is sent when events are triggered i.e gtm:removeFromCart
 * In loading events that dont need user interaction dataLayer is filled with rendered data
 * in gtm cartridge scripts
 * @returns {object}
 */
function gtmCreateEcommerceItem(data, screenName, carouselTitle, options) {
    const itemListID = $('body').find('.breadcrumbs-folder').toArray().map(el => el.textContent).join(' | ');
    var item = {};
    var settings = Object.assign({
        includePriceAndDiscount: false
    }, options || {});

    if (data.itemId) {
        item.item_id = data.itemId.toString().toLowerCase();
    }
    if (data.itemName) {
        item.item_name = data.itemName;
    }
    if (data.itemListName) {
        item.item_list_name = data.itemListName;
    } else if (screenName) {
        item.item_list_name = screenName;
    }
    if (data.itemListId) {
        item.item_list_id = data.itemListId;
    } else if (itemListID) {
        item.item_list_id = itemListID;
    } else if (screenName === 'search') {
        item.item_list_id = screenName;
    }
    if ((!item.item_list_name || !item.item_list_id) && carouselTitle && carouselTitle.length > 0) {
        item.item_list_name = 'carousel';
        item.item_list_id = carouselTitle;
    }
    if (data.itemCategory) {
        item.item_category = data.itemCategory;
    }
    if (data.itemCategory2) {
        item.item_category2 = data.itemCategory2;
    }
    if (data.itemCategory3) {
        item.item_category3 = data.itemCategory3;
    }
    if (data.itemCategory4) {
        item.item_category4 = data.itemCategory4;
    }
    if (data.itemCategory5) {
        item.item_category5 = data.itemCategory5;
    }
    if (settings.includePriceAndDiscount && data.itemPrice) {
        item.price = data.itemPrice;
    }
    if (settings.includePriceAndDiscount && data.itemDiscount) {
        item.discount = data.itemDiscount;
    }
    if (data.itemBundle) {
        item.item_bundle = data.itemBundle;
    } else if (data.isBundle) {
        item.item_bundle = 'true';
    } else {
        item.item_bundle = 'false';
    }

    if (data.promotionIds) {
        item.promotion_id = data.promotionIds;
    }
    if (data.promotionName) {
        item.promotion_name = data.promotionName;
    }

    if (item.item_bundle !== 'false') {
        item.item_bundle_name = data.itemBundleName || data.itemName;
    }

    var hasExplicitIndex = data.itemIndex !== undefined && data.itemIndex !== null && data.itemIndex !== '';
    var index = hasExplicitIndex ? Number(data.itemIndex) : (screenName === 'pdp' ? 0 : Number(data.itemIndex));
    item.index = Number.isNaN(index) ? 0 : index;
    item.quantity = Number(data.itemQuantity) || 1;

    return item;
}

function preparePLPGtmData($target) {
    var $body = $('body');
    var screenName = $body
        .find('.breadcrumbs-folder')
        .toArray()
        .map((el) => el.textContent)
        .join(' | ');
    var customerNumber = $body.find('#customerGTMDetails').data('number') || null;
    var plpSortOrder = $body
        .find('#searchResultSelect')
        .find('option:selected')
        .text()
        .trim();
    var filterValue = '';
    var filterType = '';

    filterType = $target.parents('.refinement').data('display-name');
    filterValue = $target.is('span')
        ? $target.text().trim()
        : $target.find('span').first().text().trim();

    return {
        customerNumber: customerNumber,
        screen_name: screenName,
        plp_sort_order: plpSortOrder,
        plp_filter_results: $('.grid-footer').data('hit-count'),
        plp_filter_type: filterType,
        plp_filter_value: filterValue,
    };
}

function getAddToCartScreenName() {
    const $page = $('body > .page');
    const action = ($page.data('action') || '').toString().toLowerCase();

    if ($('#quickViewModal.show').length > 0) {
        return 'plp';
    }

    if (action.includes('cart')) {
        return 'cart_page';
    }

    if ($('.pdp-container').length > 0 || action.includes('product')) {
        return 'pdp';
    }

    if (action.includes('search')) {
        if ($('.search-results-title.d-block').length > 0) {
            return 'plp';
        }
        return 'search';
    }

    return 'plp';
}

function getSearchTrackingData() {
    var obj = {};

    var $productGrid = $('.js-product-grid');
    var $suggestionsGrid = $('.suggestions.row');

    var isSearchSuggestion = $suggestionsGrid.length && $suggestionsGrid.css('display') !== 'none';
    var isSearch = ($productGrid.length && $productGrid.data('is-search') === true) || isSearchSuggestion;
    var $searchInputEl = $('.suggestions-content input.search-field');
    var searchValue = $searchInputEl.length ? $searchInputEl.val() : '';
    var searchTerm = $('.search-results-title h1').text().trim() || searchValue;

    var searchTermText = '';
    if (isSearch) {
        searchTerm = normalizeSearchTerm(searchTerm);
        searchTermText = 'search: ' + searchTerm;
    }

    var screenSection = isSearch
        ? (isSearchSuggestion ? 'search_suggestion' : 'search_page')
        : 'plp';

    obj.screenName = screenSection === 'plp' ? 'plp' : searchTermText.toLowerCase();
    obj.screenSection = screenSection.toLowerCase();
    return obj;
}

function isMiniCartOpen() {
    return $('.minicart .popover').hasClass('show');
}

function getProductTileData($productTile) {
    var data = {};
    if ($productTile.closest('.suggestions').length > 0) {
        data.screenName = 'search';
        data.index = $('.suggestions .product-tile').index($productTile);
    }
    if ($productTile.length) {
        data.itemIndex = Number($productTile.data('itemIndex'));
    }
    return data;
}

function getTileTrackingContext($productTile) {
    var taxonomy = $('body').find('.breadcrumbs-folder').toArray().map(function (el) {
        return el.textContent.trim();
    }).filter(Boolean).join(' | ');
    var searchTerm = $('.suggestions-content input.search-field').val() || $('.search-results-title h1').text().trim() || '';
    var $imageTrigger = $productTile.find('.js-product-tile-image').first();
    var gtmTitle = $imageTrigger.data('gtmTitle');
    var gtmIsCarousel = $imageTrigger.data('gtmIsCarousel') === true || $imageTrigger.data('gtmIsCarousel') === 'true';
    var itemIndex = Number($productTile.data('itemIndex'));
    var itemListName = 'plp';
    var itemListId = taxonomy;

    searchTerm = normalizeSearchTerm(searchTerm);

    if (gtmIsCarousel) {
        itemListName = 'carousel';
        itemListId = gtmTitle || $('.recommendations-title, .pdp-recommendations-title').first().text().trim();
    } else if ($productTile.closest('.suggestions').length > 0) {
        itemListName = 'search_suggestion';
        itemListId = searchTerm ? 'search: ' + searchTerm : 'search';
    } else if ($('.js-product-grid').data('isSearch') === true && searchTerm) {
        itemListName = 'search_page';
        itemListId = 'search: ' + searchTerm;
    }

    return {
        itemListName: itemListName,
        itemListId: itemListId,
        itemIndex: Number.isNaN(itemIndex) ? 0 : itemIndex
    };
}

function parseTrackingNumber(value) {
    if (value === undefined || value === null || value === '') {
        return null;
    }

    if (typeof value === 'number') {
        return Number.isNaN(value) ? null : value;
    }

    var normalizedValue = value.toString().trim().replace(/[^0-9,.-]/g, '');

    if (!normalizedValue) {
        return null;
    }

    if (normalizedValue.indexOf(',') > -1 && normalizedValue.indexOf('.') > -1) {
        normalizedValue = normalizedValue.replace(/\./g, '').replace(',', '.');
    } else if (normalizedValue.indexOf(',') > -1) {
        normalizedValue = normalizedValue.replace(',', '.');
    }

    var parsedValue = Number(normalizedValue);

    return Number.isNaN(parsedValue) ? null : parsedValue;
}

function getDisplayedPriceData($scope) {
    if (!$scope || !$scope.length) {
        return {};
    }

    var $salesValue = $scope.find('.sales .value[content]:visible').first();
    var $listValue = $scope.find('.list .value[content]:visible').first();

    if (!$salesValue.length) {
        $salesValue = $scope.find('.sales .value[content]').first();
    }

    if (!$listValue.length) {
        $listValue = $scope.find('.list .value[content]').first();
    }

    var salesValue = parseTrackingNumber($salesValue.attr('content') || $salesValue.text());
    var listValue = parseTrackingNumber($listValue.attr('content') || $listValue.text());
    var displayedPriceData = {};

    if (salesValue !== null) {
        displayedPriceData.itemPrice = salesValue;
    }

    if (salesValue !== null && listValue !== null && listValue > salesValue) {
        displayedPriceData.itemDiscount = Number((listValue - salesValue).toFixed(2));
    }

    return displayedPriceData;
}

function getEventItemValue(item, data) {
    var price = parseTrackingNumber(item && item.price);
    var fallbackPrice = parseTrackingNumber(data && data.itemPrice);
    var quantity = Number((item && item.quantity) || (data && data.itemQuantity) || 1);
    var unitPrice = price !== null ? price : fallbackPrice;

    if (unitPrice === null) {
        return 0;
    }

    return Number((unitPrice * quantity).toFixed(2));
}

function normalizeSearchTerm(searchTerm) {
    if (!searchTerm) {
        return '';
    }

    if (searchTerm.startsWith('"') || searchTerm.startsWith('“') || searchTerm.startsWith('”')) {
        searchTerm = searchTerm.substring(1);
    }

    if (searchTerm.endsWith('"') || searchTerm.endsWith('“') || searchTerm.endsWith('”')) {
        searchTerm = searchTerm.slice(0, -1);
    }

    return searchTerm.trim();
}

function getPageName() {
    const $pageElement = $('body > .page');
    let screenName = '';

    if ($pageElement) {
        const action = $pageElement.data('action') || '';

        const screenNameMap = {
            Account: 'My Account',
            Login: 'Login page',
            Cart: 'Cart page',
            Page: 'Content Page',
            Home: 'Homepage',
            Search: 'PLP',
            Product: 'PDP',
            Order: 'Order page',
            Address: 'Addresses',
            PaymentInstruments: 'Payment methods',
            ContactUs: 'Contact-us page'
        };

        const key = Object.keys(screenNameMap).find(k => action.includes(k));
        screenName = key ? screenNameMap[key] : '';

        if (!screenName) {
            if ($pageElement.hasClass('checkout-page')) {
                screenName = 'Checkout';
            } else {
                screenName = 'Homepage';
            }
        }
    }

    return screenName;
}

function pushTrackingPayload(payload) {
    if (window.pushNormalizedTrackingEvent) {
        return window.pushNormalizedTrackingEvent(payload);
    }

    return dataLayer.push(payload);
}

function formatCartFrequency(cartFrequency) {
    if (!cartFrequency || cartFrequency === 'otp') {
        return 'otp';
    }

    return cartFrequency.toString() + ' week';
}

function getRecommendationScreenName() {
    var screenName = getAddToCartScreenName();

    if (screenName === 'cart_page' || screenName === 'pdp') {
        return screenName;
    }

    return '';
}

function getRecommendationTitle($container) {
    return $container
        .closest('.recommendations')
        .find('.recommendations-title, .pdp-recommendations-title')
        .first()
        .text()
        .trim();
}

function getRecommendationContainers() {
    return [
        {
            key: 'cart_page',
            selector: '.recommendations-wrapper .pdp-swiper-recommendations, .recommendations-wrapper .swiper-recommendations, #cart-recommendations .swiper-recommendations',
        },
        {
            key: 'pdp',
            selector: '.pdp-recommendations .pdp-swiper-recommendations',
        },
    ];
}

function isRecommendationContainerInView($container) {
    if (!$container.length) {
        return false;
    }

    var element = $container.get(0);
    var rect = element.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    var verticallyVisible = rect.top < viewportHeight && rect.bottom > 0;
    var horizontallyVisible = rect.left < viewportWidth && rect.right > 0;

    return verticallyVisible && horizontallyVisible;
}

function buildRecommendationItems($container, screenName) {
    var title = getRecommendationTitle($container);
    var items = [];

    $container.find('.swiper-slide').not('.swiper-slide-duplicate').each(function (index) {
        var $tile = $(this).find('.product-tile').first();

        if (!$tile.length) {
            return;
        }

        var data = Object.assign({}, $tile.data(), getTileTrackingContext($tile), {
            itemListName: 'carousel',
            itemListId: title,
            itemIndex: Number($tile.data('itemIndex')),
        });
        Object.assign(data, getDisplayedPriceData($tile));

        if (Number.isNaN(data.itemIndex)) {
            data.itemIndex = index;
        }

        items.push(gtmNormalizer(gtmCreateEcommerceItem(data, screenName, title)));
    });

    return {
        items: items,
        title: title,
    };
}

function pushRecommendationImpression($container, screenName) {
    if (!$container.length || !screenName) {
        return false;
    }

    var recommendationData = buildRecommendationItems($container, screenName);
    var items = recommendationData.items;
    var title = recommendationData.title;

    if (!items.length || !title) {
        return false;
    }

    window.gtmRecommendationImpressions = window.gtmRecommendationImpressions || {};

    var trackingKey = [
        screenName,
        title.toLowerCase(),
        items.map(function (item) { return item.item_id; }).join(','),
    ].join('|');

    if (window.gtmRecommendationImpressions[trackingKey]) {
        return true;
    }

    var customerNumber = $('body').find('#customerGTMDetails').data('number') || null;
    var payload = {
        event: 'view_item_list',
        screen_section: screenName,
        screen_name: screenName,
        journey: 'ecommerce',
        ecommerce: {
            currency: 'GBP',
            items: items,
        },
    };

    if (customerNumber) {
        payload.user_id = customerNumber;
    }

    dataLayer.push({ ecommerce: null });
    pushTrackingPayload(payload);
    window.gtmRecommendationImpressions[trackingKey] = true;

    return true;
}

// This events will be mostly used for those cases that require a more global scope
// gtmNormalizer is global and defined in global.isml
module.exports = {
    selectItem: function () {
        $('body').on('click', '.product-tile', function () {
            const $this = $(this);
            var data = Object.assign({}, $this.data());
            var screenName = getAddToCartScreenName();
            var searchData = getSearchTrackingData();
            var productTileData = getProductTileData($this);
            if (productTileData && productTileData.screenName) {
                screenName = productTileData.screenName;
                data.itemIndex = productTileData.index;
            }
            if (productTileData && productTileData.itemIndex >= 0) {
                data.itemIndex = productTileData.itemIndex;
            }
            Object.assign(data, getTileTrackingContext($this));
            Object.assign(data, getDisplayedPriceData($this));
            // if we are adding a bundle then we are going to use bundled products instead
            // since the SEO agency asked to add separate products instead of the unitary bundle info
            var bundledProducts = data.itemBundledProducts;
            var items = [];
            // if it is a regular bundle
            if (bundledProducts) {
                bundledProducts.forEach(function (item) {
                    items.push(
                        gtmNormalizer({
                            item_id: item.id,
                            item_name: item.productName,
                            item_brand: item.range,
                            item_category: item.gtm_product_type,
                            item_category2: item.type_age,
                            item_category3: item.tech_foodtype,
                            item_category4: data.itemCategory4,
                            item_category5: item.flavour.join(','),
                            item_list_id: data.itemListId,
                            item_list_name: data.itemListName,
                            quantity: 1,
                            index: data.itemIndex,
                            item_bundle: 'true',
                            item_bundle_name: data.itemName,
                        })
                    );
                });
            }
            // if not a regular bundle
            else {
                items.push(gtmNormalizer(gtmCreateEcommerceItem(data, screenName)));
            }

            dataLayer.push({ ecommerce: null });
            var shouldUsePageScreenName = screenName === 'cart_page' || (screenName === 'pdp' && items[0].item_list_name === 'carousel');
            pushTrackingPayload({
                event: 'select_item',
                journey: 'ecommerce',
                screen_name: shouldUsePageScreenName ? screenName : searchData.screenName,
                screen_section: shouldUsePageScreenName ? screenName : searchData.screenSection,
                product_id: items[0].item_id,
                product_name: items[0].item_name,
                ecommerce: {
                    currency: 'GBP',
                    value: items.reduce((sum, item) => sum + getEventItemValue(item, data), 0),
                    items: items,
                },
            });
        });
    },
    addToCart: function () {
        $('body').on('gtm:addToCart', function (_e, data) {
            var screenName = getAddToCartScreenName();
            var isMiniCart = isMiniCartOpen();
            var items = [];
            items.push(gtmNormalizer(gtmCreateEcommerceItem(data)));

            // pushing event to the datalayer
            dataLayer.push({ ecommerce: null });
            pushTrackingPayload({
                event: 'add_to_cart',
                click_path: 'increase_quantity',
                screen_name: isMiniCart ? 'cart_modal' : screenName,
                screen_section: isMiniCart ? 'cart_modal' : screenName,
                journey: 'ecommerce',
                purchase_type: data.purchaseType,
                cart_frequency: formatCartFrequency(data.cartFrequency),
                product_id: items[0].item_id,
                product_name: items[0].item_name,
                ecommerce: {
                    currency: 'GBP',
                    value: items.reduce((sum, item) => sum + getEventItemValue(item, data), 0),
                    items: items,
                },
            });
        });
        $('body').on('click', '.add-to-cart', function () {
            var data = Object.assign({}, $(this).data());
            // if we are adding a bundle then we are going to use bundled products instead
            // since the SEO agency asked to add separate products instead of the unitary bundle info
            var items = [];
            var screenName = getAddToCartScreenName();
            var purchaseType = '';
            var cartFrequency = '';
            if (screenName === 'pdp') {
                purchaseType = $('.pdp-subscription-selection-save-wrapper.selected').length > 0 ? 's&s' : 'otp';
                purchaseType = purchaseType === 'otp' ? purchaseType : (window.sf_isWizardSubSession !== 'false' ? 'wizard' : purchaseType);
                cartFrequency = purchaseType === 'otp' ? purchaseType : Number($('.pdp-subscription-selection-save-interval-select').val());
            } else if (screenName === 'plp') {
                purchaseType = $('#OsfSorRefillProductYes').hasClass('collapsed') ? 'otp' : 's&s';
                purchaseType = purchaseType === 'otp' ? purchaseType : (window.sf_isWizardSubSession !== 'false' ? 'wizard' : purchaseType);
                cartFrequency = purchaseType === 'otp' ? purchaseType : Number($('#SorDeliveryWeekInterval').val());
            }
            data.itemCategory5 = purchaseType;

            var isCarousel = data.tileDomain === 'recommendations' || sessionStorage.getItem(`gtmIsCarousel_${data.pid}`) === 'true';
            var carouselTitle = isCarousel ? $('.recommendations-title').text().trim() : '';
            if (data.tileDomain === 'recommendations') {
                screenName = 'cart_page';
            }
            if (!carouselTitle.length) {
                carouselTitle = sessionStorage.getItem(`gtmTitle_${data.pid}`);
            }
            if ($(this).closest('.product-tile').length) {
                Object.assign(data, getTileTrackingContext($(this).closest('.product-tile')));
            } else if (data.pid) {
                data.itemListName = sessionStorage.getItem(`gtmItemListName_${data.pid}`) || data.itemListName;
                data.itemListId = sessionStorage.getItem(`gtmItemListId_${data.pid}`) || data.itemListId;
                data.itemIndex = sessionStorage.getItem(`gtmPosition_${data.pid}`) || data.itemIndex;
            }
            var shouldUseCarouselFallback = isCarousel && (!data.itemListName || !data.itemListId);
            items.push(gtmNormalizer(gtmCreateEcommerceItem(data, screenName, shouldUseCarouselFallback ? carouselTitle : '')));
            dataLayer.push({ ecommerce: null });
            pushTrackingPayload({
                event: 'add_to_cart',
                click_path: 'add_to_cart',
                screen_name: screenName,
                screen_section: screenName,
                journey: 'ecommerce',
                purchase_type: purchaseType,
                cart_frequency: formatCartFrequency(cartFrequency),
                product_id: items[0].item_id,
                product_name: items[0].item_name,
                ecommerce: {
                    currency: 'GBP',
                    value: items.reduce((sum, item) => sum + getEventItemValue(item, data), 0),
                    items: items,
                },
            });
        });
    },
    removeFromCart: function () {
        $('body').on('gtm:removeFromCart', function (e, data) {
            var bundledProducts = data.itemBundledProducts;
            var isMiniCart = isMiniCartOpen();
            var items = [];
            // if it is a regular bundle
            if (bundledProducts) {
                bundledProducts.forEach(function (item) {
                    items.push(
                        gtmNormalizer({
                            item_id: item.id,
                            item_name: item.productName,
                            item_brand: item.range,
                            item_category: item.gtm_product_type,
                            item_category2: item.type_age,
                            item_category3: item.tech_foodtype,
                            item_category4: item.range,
                            item_category5: item.itemCategory5,
                            quantity: item.quantity * data.savedQuantity,
                            item_bundle: 'true',
                            item_bundle_name: data.itemName,
                        })
                    );
                });
            } else {
                data.itemBundledProducts = undefined;
                items.push(gtmNormalizer(gtmCreateEcommerceItem(data)));
            }
            dataLayer.push({ ecommerce: null });
            pushTrackingPayload({
                event: 'remove_from_cart',
                journey: 'ecommerce',
                click_path: data.interaction_type,
                screenName: isMiniCart ? 'cart_modal' : 'cart_page',
                screen_section: 'cart',
                purchaseType: data.purchaseType,
                cart_frequency: formatCartFrequency(data.cartFrequency),
                product_id: items[0].item_id,
                product_name: items[0].item_name,
                ecommerce: {
                    currency: 'GBP',
                    value: items.reduce((sum, item) => sum + getEventItemValue(item, data), 0),
                    items: items,
                },
            });
        });
    },
    rewardPoints: function () {
        $('body').on('gtm:rewardPoints', function (e, data) {
            pushTrackingPayload({
                event: 'nm.ecommerce',
                'event name': 'rewardPoints',
                eventCategory: 'products',
                eventAction: 'reward points exchange',
                eventLabel: parseInt(data.rewardPoints, 10).toString(),
            });
        });
    },
    stockistFind: function () {
        $('body').on('gtm:stockistFind', function (e, data) {
            pushTrackingPayload({
                event: 'nm.event',
                'event name': 'stockist_find',
                eventCategory: 'stockist',
                eventAction: data.payload.postalCode,
                eventLabel: data.count,
            });
        });
    },
    stockistClick: function () {
        $('body').on('gtm:stockistClick', function (e, data) {
            pushTrackingPayload({
                event: 'nm.event',
                'event name': 'stockist_click',
                eventCategory: 'stockist',
                eventAction: 'click',
                eventLabel:
                    data.storeName ||
                    $('div[role="dialog"]').find('.store-details').data('address'),
            });
        });
    },
    stockistCall: function () {
        $('body').on('mousedown', '.storelocator-phone', function (_e, _data) {
            pushTrackingPayload({
                event: 'nm.event',
                'event name': 'stockist_call',
                eventCategory: 'stockist',
                eventAction: 'call',
                eventLabel:
                    $(this).data('store-name') ||
                    $(this).closest('.store-details').data('address'),
            });
        });
    },
    stockistVisit: function () {
        $('body').on('mousedown', '.online-store', function (_e, _data) {
            pushTrackingPayload({
                event: 'nm.event',
                'event name': 'stockist_visit',
                eventCategory: 'stockist',
                eventAction: 'visit',
                eventLabel:
                    $(this).data('store-name') ||
                    $(this).closest('.store-details').data('address'),
            });
        });
    },
    c2c: function () {
        $('body').on('gtm:c2c', function (_e, _data) {
            pushTrackingPayload({
                event: 'nm.event',
                'event name': 'c2c',
                eventCategory: 'Phonenumber',
                eventAction: 'click',
                eventLabel:
                    $(this).data('store-name') ||
                    $(this).closest('.store-details').data('address'),
            });
        });
    },
    carousel: function () {
        $(document).ready(function () {
            if ($('.carousel').length > 0) {
                var elements = $('.carousel')
                    .find('.product-tile')
                    .parent()
                    .parent()
                    .not('[data-outofinitview]');
                var items = [];

                for (var i = 0; i < elements.length; i++) {
                    var $elem = elements.eq(i);
                    var data = Object.assign({}, $elem.find('.product-tile').data());
                    Object.assign(data, getDisplayedPriceData($elem));
                    var bundledProducts = data.itemBundledProducts;

                    if (bundledProducts) {
                        bundledProducts.forEach(function (item) {
                            items.push(
                                gtmNormalizer({
                                    item_id: item.id,
                                    item_name: item.productName,
                                    item_brand: item.range,
                                    item_category: item.gtm_product_type,
                                    item_category2: item.type_age,
                                    item_category3: item.tech_foodtype,
                                    item_category4: data.itemCategory4,
                                    item_category5: item.flavour.join(','),
                                    item_list_id:
                                        (data.itemTileDomain || 'pdCarousel') +
                                        ' | ' +
                                        window.cachedDate,
                                    item_list_name: data.itemTileDomain || 'pdCarousel',
                                    quantity: 1,
                                    index: data.itemIndex,
                                })
                            );
                        });
                    } else {
                        items.push(gtmNormalizer(gtmCreateEcommerceItem(data)));
                    }
                }
                dataLayer.push({ ecommerce: null });
                pushTrackingPayload({
                    event: 'view_item_list',
                    ecommerce: {
                        items: items,
                    },
                });
            }
        });
        // send an event every time a new product is displayed in the carousel
        $('body').on(
            'click',
            '.carousel-control-prev, .carousel-control-next',
            function () {
                var $elem;
                if ($(this).hasClass('carousel-control-next')) {
                    $elem = $(this).parent().find('.carousel-item[tabindex=-1]');
                } else if ($(this).hasClass('carousel-control-prev')) {
                    var totalItems = $(this).parent().find('.carousel-item').length;
                    var activePos = $(this)
                        .parent()
                        .find('.carousel-item.active')
                        .data('position');
                    if (activePos === 0) {
                        $elem = $(this)
                            .parent()
                            .find(`.carousel-item[data-position='${totalItems - 1}']`);
                    } else {
                        $elem = $(this)
                            .parent()
                            .find(`.carousel-item[data-position='${activePos - 1}']`);
                    }
                }
                if ($elem.length > 0) {
                    var data = Object.assign({}, $elem.find('.product-tile').data());
                    Object.assign(data, getDisplayedPriceData($elem));

                    var bundledProducts = data.itemBundledProducts;
                    var items = [];

                    // if it is a regular bundle
                    if (bundledProducts) {
                        bundledProducts.forEach(function (item) {
                            items.push(
                                gtmNormalizer({
                                    item_id: item.id,
                                    item_name: item.productName,
                                    item_brand: item.range,
                                    item_category: item.gtm_product_type,
                                    item_category2: item.type_age,
                                    item_category3: item.tech_foodtype,
                                    item_category4: data.itemCategory4,
                                    item_category5: item.flavour.join(','),
                                    item_list_id:
                                        (data.itemTileDomain || 'pdCarousel') +
                                        ' | ' +
                                        window.cachedDate,
                                    item_list_name: data.itemTileDomain || 'pdCarousel',
                                    quantity: 1,
                                    index: data.itemIndex,
                                })
                            );
                        });
                    }
                    // if not a regular bundle
                    else {
                        items.push(gtmNormalizer(gtmCreateEcommerceItem(data)));
                    }
                    dataLayer.push({ ecommerce: null });
                    pushTrackingPayload({
                        event: 'view_item_list',
                        ecommerce: {
                            items: items,
                        },
                    });
                }
            }
        );
    },
    swiper: function () {
        // send an event every time a new product is displayed in the swiper
        $('body').on(
            'click',
            '.swiper-button-prev, .swiper-button-next',
            function () {
                var numElements = $(this)
                    .parent()
                    .parent()
                    .find('.swiper')
                    .attr('numberslides');
                var $elem;
                if ($(this).hasClass('swiper-button-next')) {
                    var activePos = $(this)
                        .parent()
                        .parent()
                        .find('.swiper-slide-active')
                        .index();
                    $elem = $(this)
                        .parent()
                        .parent()
                        .find('.swiper-slide')
                        .eq(activePos + (numElements - 1));
                } else if ($(this).hasClass('swiper-button-prev')) {
                    $elem = $(this).parent().parent().find('.swiper-slide-active');
                }
                if ($elem.length > 0) {
                    var data = Object.assign({}, $elem.find('.product-tile').data());
                    Object.assign(data, getDisplayedPriceData($elem));

                    var bundledProducts = data.itemBundledProducts;
                    var items = [];

                    // if it is a regular bundle
                    if (bundledProducts) {
                        bundledProducts.forEach(function (item) {
                            items.push(
                                gtmNormalizer({
                                    item_id: item.id,
                                    item_name: item.productName,
                                    item_brand: item.range,
                                    item_category: item.gtm_product_type,
                                    item_category2: item.type_age,
                                    item_category3: item.tech_foodtype,
                                    item_category4: data.itemCategory4,
                                    item_category5: item.flavour.join(','),
                                    item_list_id:
                                        (data.itemTileDomain || 'pdCarousel') +
                                        ' | ' +
                                        window.cachedDate,
                                    item_list_name: data.itemTileDomain || 'pdCarousel',
                                    quantity: 1,
                                    index: data.itemIndex,
                                })
                            );
                        });
                    }
                    // if not a regular bundle
                    else {
                        items.push(gtmNormalizer(gtmCreateEcommerceItem(data, true)));
                    }
                    dataLayer.push({ ecommerce: null });
                    pushTrackingPayload({
                        event: 'view_item_list',
                        ecommerce: {
                            items: items,
                        },
                    });
                }
            }
        );
    },
    recommendationImpressions: function () {
        var attempts = 0;
        var maxAttempts = 12;

        function hasRecommendationContainers() {
            return getRecommendationContainers().some(function (containerConfig) {
                return $(containerConfig.selector).length > 0;
            });
        }

        function scheduleRecommendationImpressionCheck(delay) {
            attempts = 0;
            window.setTimeout(tryFireRecommendationImpressions, delay || 0);
        }

        function tryFireRecommendationImpressions() {
            attempts += 1;

            var screenName = getRecommendationScreenName();
            var targetContainers = getRecommendationContainers().filter(function (containerConfig) {
                return containerConfig.key === screenName;
            });

            if (!targetContainers.length) {
                return;
            }

            var hasPendingTiles = false;

            targetContainers.forEach(function (containerConfig) {
                var $container = $(containerConfig.selector).first();
                var tileCount = $container.find('.product-tile').length;

                if (!tileCount) {
                    hasPendingTiles = true;
                    return;
                }

                if (!isRecommendationContainerInView($container)) {
                    return;
                }

                pushRecommendationImpression($container, screenName);
            });

            if (hasPendingTiles && attempts < maxAttempts) {
                window.setTimeout(tryFireRecommendationImpressions, 250);
            }
        }

        scheduleRecommendationImpressionCheck(0);
        $(window).on('load', function () {
            scheduleRecommendationImpressionCheck(0);
        });
        $(window).on('scroll resize', function () {
            if (!hasRecommendationContainers()) {
                return;
            }
            scheduleRecommendationImpressionCheck(0);
        });
        $('body').on('gtm:recommendationsReady cart:update', function () {
            scheduleRecommendationImpressionCheck(100);
        });
    },
    /**
   * Attaches a click event handler to elements with the class 'js-logout' to push logout event details to the dataLayer.
   * The event handler retrieves customer GTM details from the DOM and pushes them to the dataLayer if available.
   *
   * @event click - Triggers when an element with the class 'js-logout' is clicked.
   * @fires dataLayer#event:logout - Pushes a logout event to the dataLayer with customer details.
   *
   * @property {string} sscid - The customer session ID retrieved from the 'data-sscid' attribute of the '#customerGTMDetails' element.
   * @property {string} number - The customer number retrieved from the 'data-number' attribute of the '#customerGTMDetails' element.
   */
    logout: function () {
        $('.js-logout').on('click', function () {
            const $GTMDetails = $('#customerGTMDetails');

            if (!$GTMDetails.length) {
                return;
            }

            const sscid = $GTMDetails.attr('data-sscid');
            const number = $GTMDetails.attr('data-number');

            if (!sscid) {
                return;
            }

            pushTrackingPayload({
                event: 'logout',
                ID18: sscid,
                customer_number: number,
            });
        });
    },
    navigation: function () {
        $('body').on('click', '.gtm-navigation-links', function (e) {
            try {
                const currentTarget = $(e.currentTarget);
                const protocol = window.location.protocol;
                const domain = window.location.hostname;
                const footerParent = currentTarget.closest('.footer-element');
                const headerParent =
                    $(document).width() < 768
                        ? currentTarget
                            .closest('.mobile-nav')
                            .find('.nav-item.rotate-arrow-icon')
                        : currentTarget.closest('.nav-item');
                const isFooter = footerParent.length > 0;
                const isLevel2 = !isFooter
                    ? currentTarget.hasClass('dropdown-link')
                    : true;
                const linkText = currentTarget.text() || '';

                if (!isFooter) {
                    pushTrackingPayload({
                        event: 'navigation_click',
                        navigation: 'header',
                        link_url: protocol + '//' + domain + currentTarget.attr('href') || '',
                        link_text: linkText.trim(),
                        lvl1: isLevel2
                            ? isFooter
                                ? $(footerParent[0]).find('.title').text().trim()
                                : $(document).width() < 768
                                    ? headerParent.find('.mobile-nav-link').text().trim()
                                    : headerParent.find('.nav-link').text().trim()
                            : linkText.trim(),
                        lvl2: isLevel2 ? linkText.trim() : '',
                        lvl3: 'TBC',
                    });
                } else {
                    var screenName = getPageName();

                    pushTrackingPayload({
                        event: 'interaction',
                        click_path: linkText.trim(),
                        screen_name: screenName,
                        screen_section: 'footer'
                    });

                    pushTrackingPayload({
                        event: 'callback request started',
                        method: 'footer link'
                    });
                }
            } catch (e) {
                console.log(e);
            }
        });
    },
    /**
   * Handles the sign-in or registration event and pushes relevant data to the dataLayer for GTM (Google Tag Manager).
   *
   * This function checks for the presence of customer GTM details in the DOM, determines if the current action is a login or registration,
   * and then pushes the appropriate event data to the dataLayer.
   *
   * @returns {void}
   */
    signIn: function () {
        const $GTMDetails = $('#customerGTMDetails');

        if (!$GTMDetails.length) {
            return;
        }

        const urlParams = new URLSearchParams(window.location.search);
        const isLogin = urlParams.get('registration') === 'false';
        const isRegistration = urlParams.get('registration') === 'submitted';
        const isCheckout = $('#checkout-main').length > 0;
        const isMagicLinkLogin = urlParams.get('emailLinkLogin') === 'true';

        if (!isLogin && !isRegistration) {
            return;
        }

        const method = $GTMDetails.attr('data-method');
        const sscid = $GTMDetails.attr('data-sscid');
        const number = $GTMDetails.attr('data-number');

        if (!method || !sscid || !number) {
            return;
        }

        const dataToPush = {
            event: isRegistration ? 'sign_up' : 'login',
            user_id: number,
            method: method, // The signup method used. Google or email etc
            journey: isCheckout ? 'checkout' : 'login',
            promotional_newsletter: $('#newsletterConfirm').is(':checked')
                ? 'true'
                : 'false'
        };

        if (isMagicLinkLogin) {
            dataToPush.method = 'magic_link';
        }

        pushTrackingPayload(dataToPush);
    },
    failedLogin: function () {
        const loginError = $('.not-found-page').attr('data-login-error');

        if (loginError && loginError.length > 0) {
            pushTrackingPayload({
                event: 'login_failure',
                method: 'Google Account',
                errorMessage: loginError,
            });
        }

        $('body').on('gtm:failedLogin', function (e, data) {
            pushTrackingPayload({
                event: 'login_failure',
                method: data.method,
                errorMessage: data.errorMessage,
            });
        });
    },
    landingPages: function () {
        $('body').on('gtm:recipeOverlay', function (e, data) {
            const dataToPush = {
                event: 'overlay',
                click_path: data.click_path,
                screen_name: 'recipes',
            };

            if (data.customerNumber) {
                dataToPush['user_id'] = data.customerNumber;
            }

            pushTrackingPayload(dataToPush);
        });

        $('body').on('gtm:clickCTA', function (e, data) {
            const dataToPush = {
                event: 'click_cta',
                click_path: data.click_path,
                screen_name: data.screen_name,
                screen_section: data.screen_section,
            };

            if (data.customerNumber) {
                dataToPush['user_id'] = data.customerNumber;
            }

            pushTrackingPayload(dataToPush);
        });
    },
    checkoutSteps: function () {
        $('body').on('gtm:checkoutStep', function () {
            const urlParams = new URLSearchParams(window.location.search);
            const isStageCustomer = urlParams.get('stage') === 'customer';
            const isHashCustomer = window.location.hash === '#customer';
            if (isStageCustomer && isHashCustomer) {
                const dataToPush = {
                    event: 'account_registration_login',
                };

                pushTrackingPayload(dataToPush);
            }
        });
    },
    statsigEvent: function () {
        $('body').on('gtm:statsigEvent', function (e, data) {
            const dataToPush = {
                event: 'experiment_viewed',
                experiment_name: data.experiment_name,
                variant_name: data.variant_name,
            };

            pushTrackingPayload(dataToPush);
        });
    },
    loginPage: function () {
        $('body').on('gtm:loginInteraction', function (e, data) {
            const dataToPush = {
                event: data.event,
                click_path: data.click_path,
                click_type: data.click_type,
                screen_name: 'login page',
            };

            if (data.journey) {
                dataToPush.journey = data.journey;
            }

            pushTrackingPayload(dataToPush);
        });
    },
    navbarClick: function () {
        var $body = $('body');

        $body.on('gtm:navbarClick', function (e, data) {
            var customerNumber =
                $body.find('#customerGTMDetails').data('number') || null;
            var params = {
                event: 'nav-bar_interaction',
                click_path: data.click_path,
                click_type: data.click_type,
            };

            if (customerNumber) {
                params['user_id'] = customerNumber;
            }

            pushTrackingPayload(params);
        });
    },
    plpApplyFilters: function () {
        $('body').on('gtm:plpApplyFilters', function (e, params) {
            const data = preparePLPGtmData(params.target);
            const dataToPush = {
                event: 'plp_apply_filter',
                journey: 'ecommerce',
                screen_name: data.screen_name,
                screen_section: 'plp',
                plp_sort_order: data.plp_sort_order,
                plp_filter_type: data.plp_filter_type,
                plp_filter_value: data.plp_filter_value,
                plp_filter_results: data.plp_filter_results,
            };

            if (data.customerNumber) {
                dataToPush['user_id'] = data.customerNumber;
            }

            pushTrackingPayload(dataToPush);
        });
    },
    plpChangeSortOrder: function () {
        $('body').on('gtm:plpSort', function (e, data) {
            var customerNumber = $('body').find('#customerGTMDetails').data('number') || null;
            var screenName = $('body').find('.breadcrumbs-folder').toArray().map((el) => el.textContent).join(' | ');
            const dataToPush = {
                event: 'plp_change_sort_order',
                journey: 'ecommerce',
                plp_sort_order: data.selectedValue,
                screen_section: 'plp',
                screen_name: screenName,
            };

            if (customerNumber) {
                dataToPush.user_id = customerNumber;
            }

            pushTrackingPayload(dataToPush);
        });
    },
    trackTrustpilotClick: function () {
        // Function to setup overlay
        function setupTrustpilotOverlay() {
            if ($('.trustpilot-widget').length === 0) {
                console.log('Trustpilot widget not found, retrying...');
                setTimeout(setupTrustpilotOverlay, 1000);
                return;
            }

            $('.trustpilot-widget').css('position', 'relative');
            $('.trustpilot-click-overlay').remove();
            $('.trustpilot-widget').append('<div class="trustpilot-click-overlay" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 9999; background: transparent; cursor: pointer;"></div>');
            $('.trustpilot-click-overlay').on('click', function () {
                var customerNumber = $('body').find('#homepage').data('customer') || null;
                var dataToPush = {
                    event: 'interaction',
                    click_type: 'banner',
                    click_path: 'trustpilot',
                    screen_name: 'homepage',
                };
                if (customerNumber) {
                    dataToPush.user_id = customerNumber;
                }

                console.log('Sending GTM data:', dataToPush);
                pushTrackingPayload(dataToPush);
                window.open('https://uk.trustpilot.com/review/www.naturesmenu.co.uk', '_blank');
            });
        }
        setupTrustpilotOverlay();
        $(document).on('DOMNodeInserted', function (e) {
            if ($(e.target).find('.trustpilot-widget').length > 0 || $(e.target).hasClass('trustpilot-widget')) {
                console.log('Trustpilot widget added to DOM, setting up overlay');
                setTimeout(setupTrustpilotOverlay, 100);
            }
        });
    },
    trackChangeCartFrequency: function () {
        $('body').on('gtm:changeCartFrequency', function (_e, data) {
            var isMiniCart = isMiniCartOpen();

            const dataToPush = {
                event: 'change_cart_frequency',
                journey: 'ecommerce',
                screen_name: isMiniCart ? 'cart_modal' : 'cart_page',
                screen_section: 'cart',
                cart_frequency: data.newInterval || 'otp',
                cart_frequency_from: data.oldInterval,
                cart_frequency_to: data.newInterval,
                purchase_type: window.purchaseType
            };

            var customerNumber = $('body').find('#customerGTMDetails').data('number') || null;
            if (customerNumber) {
                dataToPush['user_id'] = customerNumber;
            }

            pushTrackingPayload(dataToPush);
        });
    }
};
